exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".TRouteSidePanel-54b2d7c9 p{margin-bottom:15px}.TRouteSidePanel-54b2d7c9 hr{display:block;height:1px;border:0;border-top:1px solid #E0E0E0;margin:0 0;padding:0}.TRouteSidePanel-54b2d7c9 h2{margin-bottom:10px}.padWrap-ca98f19f{padding:0 20px}.ScrollingHeader-e484692e{padding:10px 20px}.ScrollingHeader-e484692e h1{margin:0 0 5px 0}.ScrollingHeader-e484692e .titleAuthor-c79bc631{margin:30px 0 10px 0}.ScrollingHeader-e484692e .byline-c5dc7e98{font-weight:500}.ScrollingHeader-e484692e .departedAt-1c6c678e{font-size:13px;line-height:22px}.StickyHeader-d7f56107{width:100%;display:flex;justify-content:space-between}.description-c8b3230c{padding:20px 0 0 0}.description-c8b3230c p{margin-bottom:20px}\n", ""]);

// Exports
exports.locals = {
	"TRouteSidePanel": "TRouteSidePanel-54b2d7c9",
	"padWrap": "padWrap-ca98f19f",
	"ScrollingHeader": "ScrollingHeader-e484692e",
	"titleAuthor": "titleAuthor-c79bc631",
	"byline": "byline-c5dc7e98",
	"departedAt": "departedAt-1c6c678e",
	"StickyHeader": "StickyHeader-d7f56107",
	"description": "description-c8b3230c"
};